import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import ProductCard from '../cards/productCard';
import SubCategoryComponent from './subCategoryComponent';
import {API_URL} from "../assets/globalConstants";
import { isVisibleForSite, filterProductsForSite } from "../utils/eshopVisibility";
import { inject, observer } from "mobx-react";
import * as cloneDeep from 'lodash/cloneDeep';
import { CircularProgress } from '@mui/material';
import _useTranslate from '../hooks/_useTranslate';

const Category = ({ item, feathersStore }) => {

  let navigate = useNavigate(); 
  let common = _useTranslate(feathersStore.language, "common");

  const [subCategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [productsMapS, setProductsMapS] = useState(null);

  const productsMap = useRef(new Map());

  //used in Sorting
  const categoryIdRef = useRef(null);
  const subCategoryIdRef = useRef(null);

  useEffect(() => {
    productsMap.current = new Map();
    setProducts([]); 
    setSubCategories([]);
    setProductsMapS(cloneDeep(productsMap.current));
    if(item?.childrens?.length > 0){
      setSubCategories([...item.childrens.filter(s => isVisibleForSite(s) && feathersStore.categoryMatchesDaypart(s))]);
    }else feathersStore.isAuthenticated  && fetchCategoryProducts();    
  }, [item, feathersStore.searchCategory, feathersStore.isAuthenticated, productsMap,
    feathersStore.productUpdatedEvent, feathersStore.productCreatedEvent, feathersStore.tableId,
    feathersStore.preOrderBooking]) // daypart filter depends on the booking session

  const routeChange =  product =>  {    
    navigate(`/product/${encodeURIComponent(feathersStore._translateName(product))}`,{
      state: {id: `${product._id}`,  payload: product}     
    });
  }
   
  const renderSubCategoryItem = ( item, index ) => (
    <div key={index} className="inSubCategory">
      <SubCategoryComponent         
        onClick={() => fetchSubCategoryProducts(item, index)} 
        image={item.options?.href ? `${API_URL}/images/` + item.options?.href : require("../img/200_spinner.gif")} 
        name={feathersStore._translateCategoryName(item)}>
      </SubCategoryComponent>
      <div>
        { productsMapS && 
          <div className="product-grid">
          { 
            productsMapS && productsMapS.get(index) && 
              <>
                {productsMapS.get(index)?.length > 0 ?
                [...productsMapS.get(index)].map(renderProductCard) :
                <div className='column-flex-center-100 no-category-items'>
                  {common.noCategoryItemsYet}
                </div>
                } 
              </> 
          } 
          </div>
        }
      </div>
    </div>    
  );

  const renderProductCard = ( item, index ) => (
    <ProductCard
      key={index}
      image={item?.images[0] ? (`${API_URL}/images/` + item?.images[0]) : require("../img/200_spinner.gif")}
      title={feathersStore._translateName(item)}      
      description={feathersStore._translateProductShortDescription(item)}
      price={item[packagePricing() ? 'packagePrice' : 'retailPrice']}
      oldPrice={item[packagePricing() ? 'packageOldPrice' : 'oldPrice']}
      handleClick={() => routeChange(item)}
      onlyToProduct={true}
      badges={item.badges}
      soldOut={item.soldOut}
      recipes={item.sizes?.find(s => s.default)?.recipes?.length ? item.sizes.find(s => s.default).recipes : (item.recipes ?? [])}
    />         
  );

  const packagePricing = () => {
    return  feathersStore.settings?.deliveryPricing && feathersStore?.tableId === 'eshop'
      && !feathersStore.qrReadOnly();
  }

  const fetchSubCategoryProducts = async (item, index) => {
    subCategoryIdRef.current = +item.id;
    const feathersProducts = await feathersStore.productsPerCategory2(item.id); 
    const sortedProducts = filterProductsForSite([...feathersProducts], feathersStore?.tableId === 'eshop').sort(compare);
    productsMap.current.has(index) ? productsMap.current.delete(index) 
      : productsMap.current.set(index, sortedProducts) ;    
    setProductsMapS(cloneDeep(productsMap.current));   
  }

  const fetchCategoryProducts = async() => {
    categoryIdRef.current = +item.id;
    const feathersProducts = await feathersStore.productsPerCategory1(item.id);
    setProducts(filterProductsForSite([...feathersProducts], feathersStore?.tableId === 'eshop').sort(compare));
  }
  
  const compare = ( a, b) => {
    switch(feathersStore.settings?.sortingWay){     
      case "1":{
         if ( combinePositions(a) < combinePositions(b) ){
          return -1;
        }
        if ( combinePositions(a) > combinePositions(b) ){
          return 1;
        }
        return 0;        
      }
      case "2":{
        if ( a.updatedAt < b.updatedAt ){
          return -1;
        }
        if ( a.updatedAt > b.updatedAt ){
          return 1;
        }
        return 0;
      }
      default:{
        if ( a.name < b.name ){
          return -1;
        }
        if ( a.name > b.name ){
          return 1;
        }
        return 0;
      }
    }   
  }

  const combinePositions = product => {
    let category = null;
    let subcat = null;
    let apprnc = null;      
    if((subCategoryIdRef.current !== null) && (product.categoriesArray?.length > 0)){
      const index = catInd([...product.categoriesArray.map(c => c.category2)], subCategoryIdRef.current);
      category = product.categoriesArray[index]?.category1;
      subcat = product.categoriesArray[index]?.category2;
      apprnc = product?.appearanceArray?.length > 0 ? product.appearanceArray[index]?.appearance : null;
    }else if((categoryIdRef.current !== null) && (product.categoriesArray?.length > 0)){
      const index = catInd([...product.categoriesArray.map(c => c.category1)], categoryIdRef.current);
      category = product.categoriesArray[index]?.category1;
      apprnc = product?.appearanceArray?.length > 0 ? product.appearanceArray[index]?.appearance : null;
    }else{ //General sorting
      if(product?.categoriesArray?.length >0){   
        const mainCategory = product.categoriesArray[0];       
        category = mainCategory?.category1;    
        subcat = mainCategory?.category2 || null; 
        apprnc = product?.appearanceArray?.length > 0 ? product.appearanceArray[0].appearance : null;
      } 
    } 
    const catPosition = category ? catInd(feathersStore?.categories, category.id).toString().padStart(2, '0') : "99";
    const subcatPosition = subcat ? subcat.options.position.toString().padStart(2, '0') : "99";
    const appearance = apprnc ? apprnc.padStart(2, '0') : "21";
    return parseInt(`${catPosition}${subcatPosition}${appearance}`) 
  }

  const catInd = (arr, id) => {
     return arr?.length > 0 ? arr.findIndex(cat => cat.id) === id : null;
  }
    
  return(
    <div className="subCategory">
      {subCategories ? 
          subCategories.length > 0 ? subCategories.map(renderSubCategoryItem) : null
         :
         <div className="circular">
          <CircularProgress 
            color="secondary" 
            style={{ margin: 6 }} 
            size={'4rem'}            
          />
        </div>
      }     
      {products ?       
          products.length > 0  ? 
            <div className="product-grid"> 
            {  products.map(renderProductCard) } 
            </div> 
            :
            <> 
              {subCategories.length < 1 &&  
                <div className='column-flex-center-100 no-category-items'>
                  {common.noCategoryItemsYet}
                </div>
              }
            </>
        :
        <div className="circular">
          <CircularProgress 
            color="secondary" 
            style={{ margin: 6 }} 
            size={'4rem'}            
          />
        </div>
      }
    </div>
  )
               
}
 
export default inject('feathersStore')(observer(Category));